import { UserContext } from '@/context/UserContext';
import useI18n from '@/hooks/useI18n';
import { FormDataForCreateCampaign } from '@/types/interfaces';
import { formatDate } from '@/utils/dateUtils';
import React, { useContext } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

interface BrandDetailsProps {
  formData: FormDataForCreateCampaign;
}
const BrandDetailComponent: React.FC<BrandDetailsProps> = ({ formData }) => {
  const { t } = useI18n();
  const formatDateWithTime = (date?: string) => {
    if (!date) return '';

    return dayjs(date).format('DD/MM/YYYY, hh:mm A');
  };
  const formatDateWithTimeEnd = (date?: string) => {
    if (!date) return '';
    const cleaned = date.replace('Z', '');
    const [datePart, timePart] = cleaned.split('T');
    if (!datePart || !timePart) return '';
    const [year, month, day] = datePart.split('-');
    const [hourStr, minute] = timePart.split(':');
    let hours = parseInt(hourStr, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${day}/${month}/${year}, ${String(hours).padStart(2, '0')}:${minute} ${ampm}`;
  };
  const startDate = formatDateWithTime(formData?.startDate);
  const endDate = formData?.runCampaignTillMoneyEnd
    ? String(t('common.untilTheBudgetEnds'))
    : formData?.endDate
      ? formatDateWithTimeEnd(formData.endDate)
      : '';

  const userContext = useContext(UserContext);

  if (!userContext) {
    throw new Error('useContext must be used within a UserProvider');
  }
  const { user } = userContext;

  return (
    <div className="p-4 gap-[20px] flex flex-col">
      <div className="flex gap-4 items-center ">
        <div className="w-[32px] h-[32px] bg-[#06B217] text-white rounded-full text-2xl text-center">
          1
        </div>
        <span className="text-[#172B4D] text-base font-semibold">
          {t('common.campaignDetails')}
        </span>
      </div>
      <div className="flex gap-[32px] ">
        <div className="flex-shrink-0 w-[117px]">
          <span className="text-[#9B919D] text-sm font-normal">
            {t('common.brandLogo')}
          </span>
          <img
            src={formData?.brandLogo}
            className="w-[117px] h-[117px] rounded-full mt-1"
          />
        </div>
        <div className="flex gap-[20px] flex-col  flex-1 min-w-0">
          <div>
            <span className="text-[#9B919D] text-sm font-normal">
              {t('profile.brandName')}
            </span>
            <div className="text-[#292828] text-lg font-normal break-words whitespace-normal">
              {formData?.brandName}
            </div>
          </div>
          <div>
            <span className="text-[#9B919D] text-sm font-normal">
              {t('common.brandDescription')}
            </span>
            <div className="text-[#292828] text-lg font-normal break-words whitespace-normal">
              {formData?.brandDescription}
            </div>
          </div>
          <div className="flex gap-4">
            <div>
              <span className="text-[#9B919D] text-sm font-normal">
                {t('common.startDate')}
              </span>
              <div className="text-[#292828] text-lg font-normal ">
                {startDate}
              </div>
            </div>
            <div>
              <span className="text-[#9B919D] text-sm font-normal">
                {t('common.endDate')}
              </span>
              <div className="text-[#292828] text-lg font-normal ">
                {endDate}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandDetailComponent;
